import {
    Input,
    Component,
    Output,
    EventEmitter,
    Inject
} from '@angular/core';

import { TOAST_DATA } from '../toastr.service';

@Component({
    selector: 'app-toast-under-development',
    templateUrl: './toast-under-development.component.pug',
    styleUrls: ['./toast-under-development.component.less'],
})
export class ToastUnderDevelopmentComponent {
    @Input() count: number = null;

    constructor(
        @Inject(TOAST_DATA) public data: any
    ) {
    }
}
